import axios from 'axios';

export default {

    //Permet de récuperer les information de l'utilisateur connecté
    get() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/me');
    },

    //Permet de modifier les informations de l'utilisateur connecté
    patch(userId, userData) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/me', userData);
    },

    //Permet de récuperer le résumé du suivi d'objectif d'un utilisateur
    getResume(userId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/user/' + userId + '/resume');
    },

    //Permet de récuperer les favoris d'un utilisateur
    getFavorites(userId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/user/' + userId + '/favorites');
    }
}
